(() => {
  // app/scripts/cart-page.js
  var CartTemplate = {
    onLoad() {
      console.log("✅ CartTemplate onLoad called");
      this.elms = {
        cartSubtotalPrice: this.container.querySelector(".js-cart-subtotal-price"),
        cartTotalPrice: this.container.querySelector(".js-cart-total-price"),
        lineItemList: this.container.getElementsByClassName("js-cart-line-item"),
        lineItemsContainer: this.container.querySelector("#cart-line-items"),
        estimateShipping: this.container.querySelector("#shipping-calculator"),
        cartForm: this.container.querySelector("#cart-form"),
        cartNote: this.container.querySelector("#cart-note"),
        checkoutSubmitButton: this.container.querySelector("#checkout-submit-button")
      };

      document.addEventListener("cart-change", this.onCartChangeHandler.bind(this));
      document.addEventListener("cart-add", this.onCartAddHandler.bind(this));
      this.initEstimateShipping();
      this.initCartNote();
      this.initCheckoutSubmitButton();
    },
    onCartAddHandler({ detail: { sections, ...lineItem } }) {
      console.log("🛒 Cart add event triggered");
      let { lineItemsContainer } = this.elms;
      lineItemsContainer.innerHTML = sections["cart-template"];
      let lineItemElement = lineItemsContainer.querySelector(`cart-line-item[data-key='${lineItem.key}']`);
      if (lineItemElement) {
        AT.scrollTo(lineItemElement, 1000, 300).then(() => {
          lineItemElement.classList.add("line-item--highlight");
          AT.debounce(() => lineItemElement.classList.remove("line-item--highlight"), 1000);
        });
      }
    },
    onCartChangeHandler({ detail: { original_total_price, total_price, item_count } }) {
      console.log("🔄 Cart change event triggered");
      let { cartSubtotalPrice, cartTotalPrice } = this.elms;
      cartSubtotalPrice.innerHTML = original_total_price.toCurrency();
      cartTotalPrice.innerHTML = total_price.toCurrency();
      this.container.setAttribute("data-status", item_count);
    },
    initEstimateShipping() {
      console.log("🚚 Initializing shipping estimator");
      let { estimateShipping } = this.elms;
      if (!estimateShipping) return;
      let estimateShippingForm = estimateShipping.querySelector("form");
      let countryElement = estimateShipping.querySelector("#shipping-calculator-country");
      let provinceElement = estimateShipping.querySelector("#shipping-calculator-province");
      let provinceParentElement = provinceElement.closest(".province");
      let messageContainer = estimateShipping.querySelector(".js-message-container");
      let errorMessage = estimateShipping.querySelector(".js-error-message");
      let resultsElement = estimateShipping.querySelector(".js-shipping-calculator-results");
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let listNoDecimalsFormat = "amount_no_decimals,amount_no_decimals_with_comma_separator,amount_no_decimals_with_space_separator";
      let defaultCountry = countryElement.dataset.default;

      countryElement.addEventListener("change", function() {
        let provinceList = JSON.parse(this.options[this.selectedIndex].dataset.provinces);
        provinceElement.innerHTML = ""; // clear existing options
        if (provinceList.length) {
          provinceParentElement.classList.remove("d-none");
          provinceList.forEach((item) => {
            let option = document.createElement("option");
            option.value = item[0];
            option.innerHTML = item[1];
            provinceElement.append(option);
          });
        } else {
          provinceParentElement.classList.add("d-none");
          provinceElement.value = "";
        }
      });

      if (defaultCountry) {
        countryElement.value = defaultCountry;
        countryElement.dispatchEvent(new Event("change"));
      }

      estimateShippingForm.addEventListener("submit", function(e) {
        e.preventDefault();
        let formData = new FormData(this);
        let searchParams = new URLSearchParams(formData).toString();
        this.classList.add("pending");

        fetch(`/cart/shipping_rates.json?${searchParams}`)
          .then((res) => res.json())
          .then(({ shipping_rates }) => {
            messageContainer.classList.add("d-none");
            if (shipping_rates.length) {
              resultsElement.querySelector("p").innerHTML = shipping_rates.length > 1
                ? theme.strings.shipping.manyRates.replace("{{number}}", shipping_rates.length)
                : theme.strings.shipping.oneRate;
              resultsElement.querySelector("ul").innerHTML = shipping_rates.reduce((accu, rate) => {
                accu += `<li>${rate.name}: ${(listNoDecimalsFormat.includes(theme.currency.format.match(placeholderRegex)[1]) ? rate.price * 100 : rate.price).toCurrency()}</li>`;
                return accu;
              }, "");
            } else {
              resultsElement.querySelector("ul").innerHTML = "";
              resultsElement.querySelector("p").innerHTML = theme.strings.shipping.notFoundRate;
            }
            resultsElement.classList.remove("d-none");
          })
          .catch((error) => {
            console.error("Shipping fetch error", error);
            errorMessage.innerHTML = `Error fetching rates`;
            messageContainer.classList.remove("d-none");
            resultsElement.classList.add("d-none");
          })
          .finally(() => this.classList.remove("pending"));
      });
    },
    initCartNote() {
      console.log("📝 Initializing cart note");
      let { cartNote, cartForm } = this.elms;
      if (cartNote) {
        cartNote.querySelector("textarea").addEventListener("input", function() {
          cartNote.querySelector(".js-char-counter").innerHTML = this.value.length;
          cartForm.querySelector("textarea[name='note']").value = this.value;
        });
      }
    },
    initCheckoutSubmitButton() {
      console.log("✅ Initializing checkout button");
      let { cartForm, checkoutSubmitButton } = this.elms;
      if (checkoutSubmitButton) {
        checkoutSubmitButton.addEventListener("click", function() {
          this.classList.add("pending");
          cartForm.querySelector("button[name='checkout']").click();
        });
      }
    }
  };

  var CartLineItem = class extends HTMLElement {
    constructor() {
      super();
      console.log("🆕 CartLineItem created");
      this.elms = {
        totalPrice: this.querySelector(".js-total-price"),
        removeButton: this.querySelector(".js-remove-btn"),
        quantityInput: this.querySelector("quantity-input")
      };
      this.onChangeHandler();
      this.onRemoveHandler();
    }
    onChangeHandler() {
      let { quantityInput, totalPrice } = this.elms;
      if (!quantityInput) return;
      console.log("🔄 CartLineItem quantity change handler initialized");
    
      const minusBtn = quantityInput.querySelector("quantity-input-minus");
      const plusBtn = quantityInput.querySelector("quantity-input-plus");
      const input = quantityInput.querySelector("input[name='quantity']");
    
      if (!minusBtn || !plusBtn || !input) {
        console.warn("⚠️ Missing quantity buttons or input");
        return;
      }
    
      const updateQuantity = (lineItemKey, newQuantity) => {
        console.log("Quantity updated to", newQuantity);
      
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: newQuantity,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("Cart updated", data);
            // Find the item and update your totalPrice
            const item = data.items.find((item) => item.key === lineItemKey);
            if (item) {
              let { final_line_price } = item;
              totalPrice.innerHTML = (final_line_price / 100).toFixed(2); // e.g., $ update
            }
            document.dispatchEvent(new CustomEvent("cart-change", { detail: data }));
          });
      };
      
    
      plusBtn.addEventListener("click", () => {
        let qty = parseInt(input.value, 10) || 1;
        qty += 1;
        input.value = qty;
        updateQuantity(this.dataset.key, qty);
      });
      
      minusBtn.addEventListener("click", () => {
        let qty = parseInt(input.value, 10) || 1;
        if (qty > 1) {
          qty -= 1;
          input.value = qty;
          updateQuantity(this.dataset.key, qty);
        }
      });
      
    }
    
    onRemoveHandler() {
      let { removeButton } = this.elms;
      if (!removeButton) return;
      removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("🗑️ Remove clicked");
        removeButton.classList.add("pending");
        this.style.height = this.offsetHeight + "px";
        Cart.remove(this.dataset.key).then((res) => {
          document.dispatchEvent(new CustomEvent("cart-change", { detail: res }));
          this.classList.add("is-removing");
          setTimeout(() => {
            this.remove();
          }, 500);
        });
      });
    }
  };

  if (!customElements.get("cart-line-item")) {
    customElements.define("cart-line-item", CartLineItem);
  }

  // Manual init:
  document.addEventListener("DOMContentLoaded", () => {
    const cartContainer = document.querySelector('[data-section-type="cart-template"]'); // Adjust selector if needed
    if (cartContainer) {
      console.log("🖐️ Found cart container, initializing CartTemplate");
      CartTemplate.container = cartContainer;
      CartTemplate.onLoad();
    } else {
      console.warn("⚠️ Cart container not found");
    }
  });
})();
